import {
  Avatar,
  CircularProgress,
  Container,
  Grid,
  Stack,
  Typography,
  Box,
  TextField,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../../component/common/Button/Button";
import delete_icon from "../../../assets/delete.png";
import profile_img from "../../../assets/profile.png";
import { themeBlue, themeOrange } from "../../../utils/colorTheme";
import Input from "../../../component/common/Input";
import { useDispatch, useSelector } from "react-redux";
import { getUserByIdAsync } from "../../../services/DashboardUsers";
import { asyncStatus } from "../../../utils/asyncStatus";
import UserOrdersTable from "../../../component/common/customTable/UserOrdersTable";
import { get_notes_by_user, add_note_async, delete_note_async, edit_note_async } from "../../../services/NotesService";
import { clearUserNotes } from "../../../store/slices/notesSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

const UsersProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Notes state
  const [newNote, setNewNote] = useState("");
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editingNoteText, setEditingNoteText] = useState("");

  const {
    get_user_by_id_status,
    get_user_by_id_data,
    update_vendor_status_status,
  } = useSelector((state) => state.dashboard_users);

  const {
    get_notes_by_user_status,
    get_notes_by_user_data,
    add_note_status,
    delete_note_status,
    edit_note_status,
  } = useSelector((state) => state.notes);

  const servicesListData = [
    {
      date: "29",
      month: "Mar",
      title: "BBQ Cleaning",
      full_date: "Tue, Feb 27, 2024 (Mor)",
      status: "Cancelled",
      price: "50",
    },
    {
      date: "28",
      month: "Mar",
      title: "BBQ Cleaning",
      full_date: "Tue, Feb 27, 2024 (Mor)",
      status: "Complete",
      price: "70",
    },
    {
      date: "27",
      month: "Mar",
      title: "BBQ Cleaning",
      full_date: "Tue, Feb 27, 2024 (Mor)",
      status: "Complete",
      price: "80",
    },
    {
      date: "26",
      month: "Mar",
      title: "BBQ Cleaning",
      full_date: "Tue, Feb 27, 2024 (Mor)",
      status: "In Process",
      price: "90",
    },
  ];

  useEffect(() => {
    dispatch(getUserByIdAsync(id));
    dispatch(get_notes_by_user(id));

    return () => {
      dispatch(clearUserNotes());
    };
  }, [id, dispatch]);

  // Note handlers
  const handleAddNote = () => {
    if (newNote.trim()) {
      dispatch(add_note_async({ userId: id, note: newNote }));
      setNewNote("");
    }
  };

  const handleDeleteNote = (noteId) => {
    dispatch(delete_note_async(noteId));
  };

  const handleEditNote = (note) => {
    setEditingNoteId(note.id);
    setEditingNoteText(note.note);
  };

  const handleSaveEdit = () => {
    if (editingNoteText.trim()) {
      dispatch(edit_note_async({ id: editingNoteId, data: { userId: id, note: editingNoteText } }));
      setEditingNoteId(null);
      setEditingNoteText("");
    }
  };

  const handleCancelEdit = () => {
    setEditingNoteId(null);
    setEditingNoteText("");
  };

  if (get_user_by_id_status === asyncStatus.LOADING) {
    return (
      <Stack alignItems={"center"} justifyContent={"center"} height={"60vh"}>
        {" "}
        <CircularProgress size={"30px"} sx={{ color: themeOrange }} />
      </Stack>
    );
  }

  return (
    <Stack bgcolor={"#FAFAFA"}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        gap={1}
        my={1}
      >
        <Typography className="mainHeading" sx={{ cursor: "pointer" }}>
          User
        </Typography>
        <Stack
          className="globleGradientBlue"
          sx={{ borderRadius: "10px", overflow: "hidden", boxShadow: "none" }}
        >
          {/* <CustomButton
            style={{
              backgroundColor: "transparent",
              fontSize: "20px",
              fontWeight: "400",
              paddingTop: "10px",
              paddingBottom: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
            }}
            onClick={() => navigate("/add-vendor")}
          >
            <img
              src={delete_icon}
              style={{ height: "24px", width: "24px", color: "white" }}
            />
            <Typography className="subHeading" sx={{ color: "white" }}>
              {" "}
              Delete
            </Typography>
          </CustomButton> */}
        </Stack>
      </Stack>
      <hr color={"#D1D1D1"} />
      <Container
        sx={{ maxWidth: { xl: "xl", lg: "lg", md: "md", sm: "sm", xs: "xs" } }}
      >
        <Stack alignItems={"center"} justifyContent={"center"} my={2}>
          <Grid container spacing={2}>
            {/* <!--------- USER PROFILE DETAIL ---------!> */}
            <Grid item xl={3} lg={3} md={4} sm={12} xs={12}>
              <Stack
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{
                  boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.15)",
                  borderRadius: "20px",
                  backgroundColor: "white",
                }}
                gap={4}
                py={4}
                px={1}
              >
                <Stack gap={2} alignItems={"center"} justifyContent={"center"}>
                  <Stack
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                  >
                    {/* <img
                      src={get_user_by_id_data?.avatar || ""}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    /> */}

                    <Avatar
                      src={get_user_by_id_data?.avatar || ""}
                      sx={{
                        height: "100%",
                        width: "100%",
                        borderRadius: "10px",
                      }}
                    />
                  </Stack>

                  <Stack
                    direction={{
                      xl: "row",
                      lg: "column",
                      md: "column",
                      sm: "row",
                      xs: "row",
                    }}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Typography
                      className="mainHeading"
                      sx={{ fontWeight: "300 !important" }}
                    >
                      {get_user_by_id_data?.first_name || "-"} &nbsp;
                    </Typography>
                    <Typography
                      className="mainHeading"
                      sx={{ color: themeOrange }}
                    >
                      {get_user_by_id_data?.last_name || ""}
                    </Typography>
                  </Stack>
                </Stack>

                <Stack sx={{ width: "90%" }}>
                  <Input
                    disabled={true}
                    id={"Email Id"}
                    type={"email"}
                    onChange={() => {}}
                    style={{
                      borderRadius: "6px",
                      boxShadow:
                        "0px 10.534px 31.601px 0px rgba(178, 178, 178, 0.20)",
                    }}
                    // placeholder={""}
                    label={"Email Id"}
                    // value={value}
                    defaultValue={get_user_by_id_data?.email || ""}
                  />
                </Stack>

                <Stack sx={{ width: "90%" }}>
                  <Input
                    disabled={true}
                    id={"Phone Number"}
                    type={"number"}
                    onChange={() => {}}
                    style={{
                      borderRadius: "6px",
                      boxShadow:
                        "0px 10.534px 31.601px 0px rgba(178, 178, 178, 0.20)",
                    }}
                    // placeholder={""}
                    label={"Phone Number"}
                    // value={value}
                    defaultValue={get_user_by_id_data?.phone || ""}
                  />
                </Stack>
              </Stack>
            </Grid>
            <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
              <Stack gap={3}>
                {/* <!--------- ALL SERVICES RECORD CARDS ---------!> */}
                <Grid container spacing={3}>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <Stack
                      justifyContent={"center"}
                      gap={3}
                      sx={{
                        boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.15)",
                        borderRadius: "20px",
                        backgroundColor: "white",
                      }}
                      px={2}
                      py={5}
                    >
                      <Typography
                        className="mainHeading"
                        sx={{ fontWeight: "700 !important" }}
                      >
                        {get_user_by_id_data?.data?.total_orders || 0}
                      </Typography>

                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                      >
                        <Typography
                          className="mainHeading"
                          sx={{ fontWeight: "300 !important" }}
                        >
                          All &nbsp;
                        </Typography>
                        <Typography
                          className="mainHeading"
                          sx={{ color: themeOrange }}
                        >
                          Services
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <Stack
                      justifyContent={"center"}
                      gap={3}
                      sx={{
                        boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.15)",
                        borderRadius: "20px",
                        backgroundColor: "white",
                      }}
                      px={2}
                      py={5}
                    >
                      <Typography
                        className="mainHeading"
                        sx={{ fontWeight: "700 !important" }}
                      >
                        {get_user_by_id_data?.data?.completed || 0}
                      </Typography>

                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                      >
                        <Typography
                          className="mainHeading"
                          sx={{ fontWeight: "300 !important" }}
                        >
                          Comp
                        </Typography>
                        <Typography
                          className="mainHeading"
                          sx={{ color: themeOrange }}
                        >
                          leted
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <Stack
                      justifyContent={"center"}
                      gap={3}
                      sx={{
                        boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.15)",
                        borderRadius: "20px",
                        backgroundColor: "white",
                      }}
                      px={2}
                      py={5}
                    >
                      <Typography
                        className="mainHeading"
                        sx={{ fontWeight: "700 !important" }}
                      >
                        {get_user_by_id_data?.data?.current || 0}
                      </Typography>

                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                      >
                        <Typography
                          className="mainHeading"
                          sx={{
                            fontWeight: "300 !important",
                            fontFamily: `Raleway, sans-serif`,
                          }}
                        >
                          {/* Cancel &nbsp; */}
                          Current&nbsp;
                        </Typography>
                        <Typography
                          className="mainHeading"
                          sx={{
                            color: themeOrange,
                            fontFamily: `Raleway, sans-serif !important`,
                          }}
                        >
                          Jobs
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>

                {/* Customer History Section */}
                <Stack
                  sx={{
                    overflow: "auto",
                    boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.15)",
                    borderRadius: "20px",
                    backgroundColor: "white",
                    minHeight: "auto",
                  }}
                >
                  <Stack
                    justifyContent={"center"}
                    sx={{
                      minWidth: "530px",
                    }}
                    px={2}
                  >
                    <Stack
                      direction="row"
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      py={2}
                      px={2}
                      sx={{ borderBottom: "1px solid #F1F1F1" }}
                      className="user_profile_services_wrapper"
                    >
                      <Stack>
                        <Typography className="mainHeading">Customer History</Typography>
                        <Typography sx={{ fontSize: "12px", color: "#888", mt: 0.5 }}>
                          Complete order and service history for this customer
                        </Typography>
                      </Stack>
                      {get_user_by_id_data?.data?.orders?.length > 0 && (
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: themeOrange,
                            fontWeight: "600",
                            backgroundColor: "rgba(241, 90, 36, 0.1)",
                            padding: "4px 12px",
                            borderRadius: "20px",
                          }}
                        >
                          {get_user_by_id_data?.data?.orders?.length} Orders
                        </Typography>
                      )}
                    </Stack>

                    {get_user_by_id_data?.data?.orders?.length > 0 ? (
                      <UserOrdersTable
                        data={get_user_by_id_data?.data?.orders}
                        onViewOrder={(orderId) => navigate(`/order-details/${orderId}`)}
                      />
                    ) : (
                      <Stack
                        sx={{ height: "28vh" }}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <Typography
                          className="mainPara"
                          sx={{
                            fontWeight: "200 !important",
                            color: themeBlue,
                            p: 0,
                            lineHeight: "22px",
                          }}
                        >
                          No order history found for this customer
                        </Typography>
                      </Stack>
                    )}
                  </Stack>
                </Stack>

                {/* Admin Notes Section */}
                <Stack
                  sx={{
                    boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.15)",
                    borderRadius: "20px",
                    backgroundColor: "white",
                  }}
                >
                  <Stack
                    alignItems={"flex-start"}
                    justifyContent={"center"}
                    py={2}
                    px={3}
                    sx={{ borderBottom: "1px solid #F1F1F1" }}
                  >
                    <Typography className="mainHeading">Admin Notes</Typography>
                    <Typography sx={{ fontSize: "12px", color: "#888", mt: 0.5 }}>
                      Private notes about this user (only visible to admins)
                    </Typography>
                  </Stack>

                  {/* Add New Note */}
                  <Stack px={3} py={2} sx={{ borderBottom: "1px solid #F1F1F1" }}>
                    <TextField
                      multiline
                      rows={2}
                      placeholder="Write a note about this user..."
                      value={newNote}
                      onChange={(e) => setNewNote(e.target.value)}
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                          fontSize: "14px",
                        },
                      }}
                    />
                    <Stack direction="row" justifyContent="flex-end" mt={1}>
                      <CustomButton
                        onClick={handleAddNote}
                        disable={!newNote.trim() || add_note_status === asyncStatus.LOADING}
                        style={{
                          background: "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                          padding: "8px 20px",
                          borderRadius: "8px",
                          opacity: !newNote.trim() ? 0.6 : 1,
                        }}
                      >
                        {add_note_status === asyncStatus.LOADING ? (
                          <CircularProgress size={16} sx={{ color: "white" }} />
                        ) : (
                          <Typography sx={{ fontSize: "13px !important" }}>Add Note</Typography>
                        )}
                      </CustomButton>
                    </Stack>
                  </Stack>

                  {/* Notes List */}
                  <Stack px={3} py={2} gap={2} sx={{ maxHeight: "400px", overflow: "auto" }}>
                    {get_notes_by_user_status === asyncStatus.LOADING ? (
                      <Stack alignItems="center" py={4}>
                        <CircularProgress size={24} sx={{ color: themeOrange }} />
                      </Stack>
                    ) : get_notes_by_user_data?.length > 0 ? (
                      get_notes_by_user_data.map((note) => (
                        <Box
                          key={note.id}
                          sx={{
                            backgroundColor: "#f9f9f9",
                            borderRadius: "10px",
                            padding: "12px 16px",
                            border: "1px solid #eee",
                          }}
                        >
                          {editingNoteId === note.id ? (
                            <Stack gap={1}>
                              <TextField
                                multiline
                                rows={2}
                                value={editingNoteText}
                                onChange={(e) => setEditingNoteText(e.target.value)}
                                fullWidth
                                size="small"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    backgroundColor: "white",
                                  },
                                }}
                              />
                              <Stack direction="row" justifyContent="flex-end" gap={1}>
                                <IconButton
                                  size="small"
                                  onClick={handleCancelEdit}
                                  sx={{ color: "#888" }}
                                >
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={handleSaveEdit}
                                  sx={{ color: themeOrange }}
                                  disabled={edit_note_status === asyncStatus.LOADING}
                                >
                                  {edit_note_status === asyncStatus.LOADING ? (
                                    <CircularProgress size={16} />
                                  ) : (
                                    <SaveIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </Stack>
                            </Stack>
                          ) : (
                            <>
                              <Typography sx={{ fontSize: "14px", color: "#333", lineHeight: 1.6 }}>
                                {note.note}
                              </Typography>
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                mt={1}
                              >
                                <Typography sx={{ fontSize: "11px", color: "#999" }}>
                                  {new Date(note.created_at).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </Typography>
                                <Stack direction="row" gap={0.5}>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleEditNote(note)}
                                    sx={{ color: "#666", "&:hover": { color: themeOrange } }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteNote(note.id)}
                                    sx={{ color: "#666", "&:hover": { color: "#d32f2f" } }}
                                    disabled={delete_note_status === asyncStatus.LOADING}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Stack>
                              </Stack>
                            </>
                          )}
                        </Box>
                      ))
                    ) : (
                      <Stack alignItems="center" py={4}>
                        <Typography sx={{ fontSize: "14px", color: "#999", fontStyle: "italic" }}>
                          No notes yet. Add your first note above.
                        </Typography>
                      </Stack>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Stack>
  );
};

export default UsersProfile;
